<div class="iframe">
  <mat-icon class="back-arrow" (click)="goBack()">keyboard_backspace</mat-icon>
  <iframe [src]="url" width="100%" height="100%" frameBorder="0" allowfullscreen="allowfullscreen"></iframe>
</div>
